import React from 'react';

import './card.scss';

const Card = ({ children, className, bgColor }) => {
  return (
    <div className={`card ${className}`}>
      <div
        className='card__content-container'
        style={{ backgroundColor: bgColor }}
      >
        <div className='card__content'>{children}</div>
      </div>
    </div>
  )
};

export default Card



// WEBPACK FOOTER //
// ./src/components/Card/index.js